import { styled } from 'styled-components'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'
import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from '@/buyer-portal/components/layouts/CardLayout/card/ui'
import { FeatureFlags } from '@/helpers/featureFlags'

const StyledBanner = styled(Banner)`
  padding: 1rem 1.5rem;
  width: 100%;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 0 1.5rem;
`

const Title = styled.h2`
  ${Typography.Title2}
  margin: 0;
  padding: 0;
`

export const Unmanifested = () => {
  const enableLdpRedesign = useFlag(FeatureFlags.ENABLE_LDP_REDESIGN)

  return enableLdpRedesign ? (
    <Card>
      <CardHeader>
        <CardTitle>
          <FormattedMessage id="Auction.manifest.unmanifested.title" />
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Banner>
          <FormattedMessage id="Auction.manifest.unmanifested.description" />
        </Banner>
      </CardBody>
    </Card>
  ) : (
    <Body>
      <Title>
        <FormattedMessage id="Auction.manifest.unmanifested.title" />
      </Title>
      <StyledBanner>
        <FormattedMessage id="Auction.manifest.unmanifested.description" />
      </StyledBanner>
    </Body>
  )
}
